import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Input,
  List,
  ListItem,
  Box,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
} from "@chakra-ui/react";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCloseModal, addCalendarFood } from "../store/calendarSlice";

const time = ["", "Өглөө", "Бага үд", "Өдөр", "Их үд"];

const SelectFood = () => {
  const dispatch = useDispatch();
  const model = useSelector(({ food }) => food.calendarSlice.model);
  const foodOptions = useSelector(({ food }) => food.calendarSlice.foodOptions);

  const [searchValue, setSearchValue] = useState("");
  const [filteredOptions, setFilteredOptions] = useState([]);

  useEffect(() => {
    setFilteredOptions(foodOptions);
  }, [foodOptions]);

  const onClose = () => {
    dispatch(setCloseModal());
    setSearchValue("");
    setFilteredOptions(foodOptions);
  };

  const handleAddFood = (food) => {
    const payload = {
      food: food.id,
      food_name: food.name,
      time: model.time,
      date: model.date,
      angiud: model.course,
    };

    dispatch(addCalendarFood(payload));
    setSearchValue("");
    setFilteredOptions(foodOptions);
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchValue(value);

    // Filter type_foods by type === 1
    const filtered = foodOptions.map((item) => ({
      ...item,
      type_foods: item.type_foods.filter((food) =>
        food.name.toLowerCase().includes(value.toLowerCase())
      ),
    }));

    setFilteredOptions(filtered);
  };

  return (
    <Modal isOpen={model.open} onClose={onClose}>
      <ModalOverlay />
      <ModalContent w="750px" maxW="90%">
        <ModalHeader>
          <div className="flex items-center gap-3">
            Хоол нэмэх
            <div className="text-[13px] font-normal mt-[3px]">
              {time[model.time]} /{model.date}/
            </div>
          </div>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Input
            placeholder="Хайх..."
            value={searchValue}
            onChange={handleSearch}
            mb="4"
          />

          <Tabs>
            <TabList>
              {filteredOptions.map((f, i) => (
                <Tab key={f.id} className="font-semibold !text-[14px]">
                  {f.name}
                </Tab>
              ))}
            </TabList>

            <TabPanels>
              {filteredOptions.map((option) => {
                return (
                  <TabPanel>
                    <Box maxH="350px" minH="300px" overflowY="auto" mb="5">
                      <List spacing={3}>
                        {option.type_foods.map((option) => (
                          <ListItem
                            key={option.id}
                            py="2"
                            px="4"
                            cursor="pointer"
                            bg="gray.100"
                            fontSize="sm"
                            _hover={{ bg: "blue.300", color: "white" }}
                            borderRadius="md"
                            onClick={() => handleAddFood(option)}
                          >
                            {option.name}
                          </ListItem>
                        ))}
                      </List>
                    </Box>
                  </TabPanel>
                );
              })}
            </TabPanels>
          </Tabs>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default SelectFood;
